import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import * as dealApis from "../../utilities/apis/deal"
import Layout from "../../components/Layout"

const ReportIncomeStatement = () => {
  const { user, token } = useSelector(state => state.user)
  const params = new URLSearchParams(window.location.search)
  const navigate = useNavigate()
  const advertisementRef = useRef(null)
  const labourRef = useRef(null)
  const packingRef = useRef(null)

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const formData = new FormData()
      formData.append("advertisement", advertisementRef.current ? advertisementRef.current.value : '')
      formData.append("labour", labourRef.current ? labourRef.current.value : '')
      formData.append("packing", packingRef.current ? packingRef.current.value : '')

      if (!params.has("id")) {
        const response = await dealApis.createDeal(token, formData)
        if (!response.status) throw new Error(response.message)

        advertisementRef.current.value = ""
        labourRef.current.value = ""
        packingRef.current.value = ""

      } else {
        formData.append("id", parseInt(params.get("id")))
        const response = await dealApis.updateDeal(token, formData)
        if (!response.status) throw new Error(response.message)
      }

      alert("Income Statement created")
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (!user) navigate("/")

  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="w-25 mx-auto">
          <form method="POST" onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex gap-3 align-items-center">
                <button type="button" className="btn btn-secondary rounded-4" onClick={() => navigate(-1)}><i className="bi bi-chevron-left"></i></button>
                <p className="lead text-body-emphasis fw-bold m-0">Income Statement Settings</p>
              </div>

              <div className="card rounded-4 shadow-none">
                <div className="card-body py-4">
                  <div className="d-flex flex-column gap-3">
                    <div>
                      <label htmlFor="advertisement" className="form-label">Advertisement</label>
                      <input ref={advertisementRef} type="number" step="0.01" className="form-control" id="advertisement" required />
                    </div>
                    <div>
                      <label htmlFor="labour" className="form-label">Labour</label>
                      <input ref={labourRef} type="number" step="0.01" className="form-control" id="labour" required />
                    </div>
                    <div>
                      <label htmlFor="packing" className="form-label">Packing</label>
                      <input ref={packingRef} type="number" step="0.01" className="form-control" id="packing" required />
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button type="submit" className="btn btn-theme rounded-4 w-25">Save</button>
              </div>
            </div>
          </form>
        </div>
      </main>
    </Layout>
  )
}

export default ReportIncomeStatement